import EF from 'ef/ef';
import Menu from 'models/menu';
import { KeybindingService, keys } from 'services/event-handler-services/keybinding-service';
import LocaleService from 'services/loader-handler-services/locale-service';
import ContentService from 'services/loader-handler-services/content-service';
import { SessionStorageService } from 'services/data-handler-services/web-storage-service';
import CourseSettingsService from 'services/course-handler-services/course-settings-service';
import ContentProvider from 'services/content-provider';

import View from 'views/base/view';
import MenuView from 'views/menu/menu-view';
import CssView from 'views/css/css-view';
import DialogView from 'views/dialog/dialog-view';
import ForgeEditorView from 'views/forge-editor/forge-editor-view';

import CompatibilityView from 'views/compatibility/compatibility-view';
import DeveloperToolbarView from 'developer/views/toolbar/toolbar-view';
import GuidesOverlayView from 'developer/views/toolbar/guides-overlay-view';
import SiteTemplate from 'views/site/templates/site';
import $ from 'jquery';

const { Tab } = keys;

const SiteView = View.extend({
  container: 'body',
  id: 'site-container',
  regions: {
    main: '#main-container',
    compatibility: '.site-compatibility',
    portfolio: '.site-portfolio',
    devbar: '.developer-toolbar',
    css: '.css',
    dialog: '.dialog',
  },
  template: SiteTemplate,
  className() {
    return [EF.enrollment.get('demoMode') ? 'preview' : 'not-preview', this.model.get('progressProvider')].join(' ');
  },
  initialize: function () {
    this.on('addedToDOM', this.addEventDelegates);
    this.refresh();
    if (SessionStorageService.getItem('overlayEnabled') === true) {
      const guidesOverlayView = new GuidesOverlayView();
      guidesOverlayView.render();
    }
    if (EF.forgeMode) {
      this.ForgeEditorView = new ForgeEditorView(!!EF.editMode);
    }
    View.prototype.initialize.apply(this, arguments);
  },
  refresh: function () {
    this.$el.attr('data-controller', this.model.get('controller'));
  },
  addEventDelegates: function () {
    const self = this;
    if (LocaleService.isRTL()) {
      // Adding dir attribute to site-container rather than the body, to not affect foundry.
      this.$el.attr('dir', 'rtl');
    }
    $('body').addClass('sdk-loaded');
    ContentProvider.SiteService.addSponsorClass();
    if (CourseSettingsService.get('disableBranding')) {
      $('body').addClass('no-branding');
    }
    $('#site-container').addClass(`${LocaleService.getLanguage()} focus-hide`);

    this.delegate('keydown', function (e) {
      if ($(e.target).prop('tagName') !== 'INPUT') {
        KeybindingService.with(e).bind(Tab, () => {
          $('#site-container').removeClass('focus-hide');
          $('body').removeClass('focus-hide');
        });
      }
    });

    const dialogView = new DialogView({
      region: 'dialog',
    });
    this.subview('dialog', dialogView);

    this.delegate('click', '#portfolio_button', function (e) {
      e.preventDefault();

      if (this.portfolioShowing) {
        this.closePortfolio();
      } else {
        this.publishEvent('action:pause');
        this.$('#portfolio_button').addClass('open').html(LocaleService.t('portfolioButtonOpen'));

        const menuSettings = CourseSettingsService.get('menu');
        const menu = new Menu(menuSettings);
        const menuKey = menuSettings.portfolioPage;
        menu.set('key', menuKey);
        ContentService.applyContentAndLocale(menu, `menu.${menuKey}`, true).then(model => {
          const menuView = new MenuView({
            className: menuKey,
            model: model,
            region: 'portfolio',
          });
          menuView.container.focus();
          this.listenTo(menuView, 'close', this.closePortfolio);
          this.subview('portfolio', menuView);
          this.portfolioShowing = true;
        });
      }
    });

    this.delegate('click', '#developer_button', function (e) {
      e.preventDefault();

      if (this.devBarShowing) {
        $('.developer-toolbar').hide();
        this.subviewsByName.devBar.dispose();
      } else {
        const devBarView = new DeveloperToolbarView({
          region: 'devbar',
        });

        this.subview('devBar', devBarView);
        $('.developer-toolbar').show();
        devBarView.delegate('click', '[data-close]', function () {
          $('.developer-toolbar').hide();
          self.subviewsByName.devBar.dispose();
          self.devBarShowing = false;
        });
      }
      this.devBarShowing = !this.devBarShowing;
    });

    let customTemplate = this.model.get('cssTemplate') ? this.model.get('cssTemplate') : 'stylesheets/custom';
    if (customTemplate === true) {
      customTemplate = 'stylesheets/custom';
    }
    const cssView = new CssView({
      model: EF.customizations.findByType('css-customization'),
      template: customTemplate,
      region: 'css',
    });
    this.subview('cssView', cssView);

    if (
      CourseSettingsService.get('showCompatibilityWarning') &&
      !SessionStorageService.getItem('compatibility-closed')
    ) {
      const compatView = new CompatibilityView({
        model: this.model,
        region: 'compatibility',
      });
      compatView.delegate('click', '[data-close]', function () {
        SessionStorageService.setItem('compatibility-closed', true);
        $('.site-compatibility').hide();
        if (self.subviewsByName && self.subviewsByName.compatibility) {
          self.subviewsByName.compatibility.dispose();
        }
      });
      this.subview('compatibility', compatView);
    }
  },
  closePortfolio() {
    this.publishEvent('action:resume');
    if (this.subviewsByName.portfolio) {
      this.subviewsByName.portfolio.dispose();
    }
    this.$('#portfolio_button').removeClass('open').html(LocaleService.t('portfolioButton'));

    this.portfolioShowing = false;
    this.$('#portfolio_button').trigger('focus');
  },
});

export default SiteView;
